<template>
  <div>
    <v-simple-table fixed-header>
      <template #default>
        <thead>
          <tr class="bg-dark">
            <th class="bg-dark text-center text-light">ประเภท</th>
            <th class="bg-dark text-center text-light">เลขแทง</th>
            <th class="bg-dark text-center text-light">ยอดแทง</th>
            <th class="bg-dark text-center text-light">ยอดถูก</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in numberTop" :key="item.id">
            <td class="text-center">
              <v-chip
                v-if="item.slug === 'any_upper'"
                class="ma-2"
                label
                small
                color="success"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === 'any_under'"
                class="ma-2"
                label
                small
                color="warning"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '2upper'"
                class="ma-2"
                label
                small
                color="primary"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '2under'"
                class="ma-2"
                label
                small
                color="red lighten-2"
                text-color="white"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '3upper'"
                class="ma-2"
                label
                small
                color="pink darken-1"
                text-color="white"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '3shuffle'"
                class="ma-2"
                label
                small
                color="danger"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '3front'"
                class="ma-2"
                label
                small
                color="blue-grey"
                text-color="white"
              >
                {{ constants[item.slug] }}
              </v-chip>
              <v-chip
                v-else-if="item.slug === '3back'"
                class="ma-2"
                label
                small
                color="brown"
                text-color="white"
              >
                {{ constants[item.slug] }}
              </v-chip>
            </td>
            <td class="text-center">
              {{ item.digits }}
            </td>
            <td>
              <span class="text-monospace text-center text-success d-block">
                {{ Intl.NumberFormat("en-US").format(item.amount) }}</span
              >
            </td>
            <td>
              <span class="text-monospace text-center text-success d-block">{{
                Intl.NumberFormat("en-US").format(item.prize)
              }}</span>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-model="preload" persistent width="500" max-width="100vw">
      <v-card class="pa-md-10 mx-lg-auto">
        <v-container class="text-center">
          <v-progress-circular
            :size="100"
            :width="10"
            indeterminate
            color="primary"
          />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "TicketNumberTop",
  props: {
    gameId: { default: "", Type: Number },
  },
  data: () => ({
    slugName: "",
    numberTop: [],
    constants: [],
    preload: false,
  }),
  computed: {},
  created() {
    this.getNumberTop();
  },
  methods: {
    getNumberTop() {
      if (this.gameId) {
        this.preload = true;
        axios
          .get(`/management/getDigitTop/${this.gameId}`)
          .then((response) => {
            this.numberTop = response.data.number;
            this.constants = response.data.constants;
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.preload = false;
          });
      }
    },
  },
};
</script>
